// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Fo5z","selects":"Documents_selects__3sOHH"};